var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescktopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 189,
    viewBox: "0 0 438 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.655 178.716h56.83l9.996 2.363-76.822.058 9.996-2.421z",
    fill: "#D0D6DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.959 182.391H136.18l-.5-1.254 76.801-.058-.522 1.312zM202.484 178.716h-56.829l3.251-24.451h50.791l2.787 24.451z",
    fill: "#81858A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62 133.786v15.096a5.59 5.59 0 005.575 5.575h212.99a5.593 5.593 0 005.571-5.575v-15.096H62z",
    fill: "#D0D6DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.135 5.575A5.588 5.588 0 00280.564 0H67.574A5.59 5.59 0 0062 5.575v128.211h224.135V5.575z",
    fill: "#3E3D40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.245 7.434H69.898v118.922h208.347V7.434z",
    fill: "#ECEDED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.055 144.779a3.985 3.985 0 01-2.461 3.684 3.985 3.985 0 01-5.436-2.906 3.99 3.99 0 011.695-4.093 3.987 3.987 0 016.202 3.315zM409.617 83H271.072a3.503 3.503 0 00-3.49 3.49v92.332h145.526V86.49a3.505 3.505 0 00-3.491-3.49z",
    fill: "#3E3D40"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M406.78 89.017H274.056v85.278H406.78V89.017z",
    fill: "#ECEDED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M428.704 187.442H251.743l-8.732-3.201h194.425l-8.732 3.201z",
    fill: "#81858A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M340.827 86.603a.614.614 0 01-.383.573.622.622 0 01-.845-.454.618.618 0 01.848-.691.616.616 0 01.38.572z",
    fill: "#87888A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M355.92 178.808h-31.509v3.2h31.509v-3.2z",
    fill: "#B1B3B4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M353.419 178.808v1.149a1.45 1.45 0 01-1.45 1.45h-23.56a1.45 1.45 0 01-1.45-1.45v-1.164H243v5.437h194.429v-5.437l-84.01.015z",
    fill: "#D0D6DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.322 183.786a4.417 4.417 0 01-4.404 4.404H4.4a4.417 4.417 0 01-4.4-4.404V93.404A4.418 4.418 0 014.4 89h67.518a4.415 4.415 0 014.404 4.404v90.382z",
    fill: "#3E3D40"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.924 97.434H7.401v82.318h61.523V97.434z",
    fill: "#ECEDED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.142 93.52a.979.979 0 11-1.958.007.979.979 0 011.958-.007z",
    fill: "#58585A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.874 183.655a1.713 1.713 0 01-2.05 1.682 1.721 1.721 0 01-1.346-1.349 1.714 1.714 0 113.396-.333z",
    fill: "#87888A"
  })));
}
export default SvgDescktopIcon;